import React from "react";

const LandingPageSectionTitle = ({ strongText, text }) => {
	return (
		<div className="offers-landing-page--section-title">
			<div>
				<hr />
				<strong>{ strongText }</strong>
				<hr />
			</div>
			<p>{ text }</p>
		</div>
	);
};

export default LandingPageSectionTitle;
